export default __webpack_public_path__ + "menu-discounts-icon.bb886b229304794a64b9bfa9889e4c76.svg";